<template>
  <div>
    <label>{{ title }}</label>
    <div class="row form-group2">
      <el-select
        :disabled="disabled"
        :value="value"
        class="col-md-8 select-info"
        size="large"
        @input="$emit('input', $event)"
      >
        <el-option
          v-for="option in selects.addressTypes"
          :value="option.value"
          :label="option.label"
          :key="option.value"
          class="select-info"
        />
      </el-select>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SelectAddressType',
  props: ['value', 'title', 'disabled'],
  data() {
    return {
      selects: {
        simple: '',
        addressTypes: [
          {
            key: 'key',
            value: 'value',
          },
        ],
      },
    };
  },
  created() {
    this.fetchData();
    this.selects.simple = this.value;
  },
  methods: {
    fetchData() {
      return this.$http
        .get(`${process.env.VUE_APP_ANNUAIRE_API_URL}/addresstypesEntities`)
        .then(response => {
          this.selects.addressTypes = response.data._embedded.addresstypesEntities.map(
            entity => ({
              value: entity.addrtypeId,
              label: entity.addrtypeLibelle,
            }),
          );
        });
    },
  },
};
</script>

<style>
.form-group2 {
  margin-bottom: 10px;
}
.el-select .el-input.is-disabled .el-input__inner {
  cursor: not-allowed;
  color: #66615b;
  background-color: lightgray;
  border: #66615b;
}
</style>
